import {UptimeBar} from "@uptime-com/uptimebar";
import {type ComponentProps} from "react";
import "@uptime-com/uptimebar/styles";

import {useMediaQuery} from "@/lib/hooks/useMediaQuery.ts";

import styles from "./ScrollableUptimeBar.module.scss";

type ScrollableUptimeBarProps = ComponentProps<typeof UptimeBar> & {
  enableMobileScroll?: boolean;
};

export const ScrollableUptimeBar = ({
  maxNumberOfLabels,
  enableMobileScroll = false,
  ...rest
}: ScrollableUptimeBarProps) => {
  const isMobile = useMediaQuery("(max-width: 767px)");

  if (enableMobileScroll && isMobile) {
    return (
      <div className={styles.scrollContainer}>
        <UptimeBar {...rest} maxNumberOfLabels={2} />
      </div>
    );
  }

  return <UptimeBar {...rest} maxNumberOfLabels={maxNumberOfLabels} />;
};
